import React from 'react';
import { ThumbsUp } from 'lucide-react';
export function CommentSection() {
  return <section className="mt-12 border-t border-gray-200 pt-8" data-id="element-160">
      <h3 className="text-lg font-bold mb-6" data-id="element-161">Reader Comments</h3>
      <div className="space-y-6" data-id="element-162">
        <Comment name="James Reynolds" comment="Why am I just hearing about this only now?? I didn't really think this was going to work! To everyone who is reading: TRY THIS NOW!" likes={51} time="1 day ago" data-id="element-163" />
        <Comment name="Allen Klein" comment="At 55 I didn't think I can go back to anything else than a dad - bod. This is absolutely mind blowing!" likes={48} time="2 days ago" data-id="element-164" />
        <Comment name="Richard Santos" comment="This method is just something else. Coach Dean if you are seeing these comments then I want you to know that I thank you deeply with all my heart." likes={150} time="3 days ago" data-id="element-165" />
      </div>
    </section>;
}
function Comment({
  name,
  comment,
  likes,
  time
}: {
  name: string;
  comment: string;
  likes: number;
  time: string;
}) {
  return <div className="flex space-x-4" data-id="element-166">
      <div className="flex-shrink-0" data-id="element-167">
        <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center" data-id="element-168">
          <span className="text-gray-600 font-semibold" data-id="element-169">{name.charAt(0)}</span>
        </div>
      </div>
      <div className="flex-grow" data-id="element-170">
        <div className="bg-gray-100 p-3 rounded-lg" data-id="element-171">
          <p className="font-semibold text-sm" data-id="element-172">{name}</p>
          <p className="text-sm mt-1" data-id="element-173">{comment}</p>
        </div>
        <div className="flex items-center mt-2 text-xs text-gray-500" data-id="element-174">
          <button className="flex items-center hover:text-gray-700" data-id="element-175">
            Like
          </button>
          <span className="mx-2" data-id="element-176">•</span>
          <button className="hover:text-gray-700" data-id="element-177">Reply</button>
          <span className="mx-2" data-id="element-178">•</span>
          <span data-id="element-179">{time}</span>
          <div className="ml-auto flex items-center" data-id="element-180">
            <ThumbsUp className="w-3 h-3 mr-1" data-id="element-181" />
            <span data-id="element-182">{likes}</span>
          </div>
        </div>
      </div>
    </div>;
}